"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "changeVolume", {
  enumerable: true,
  get: function get() {
    return _changeVolume["default"];
  }
});
Object.defineProperty(exports, "togglePlay", {
  enumerable: true,
  get: function get() {
    return _togglePlay["default"];
  }
});
var _togglePlay = _interopRequireDefault(require("./togglePlay"));
var _changeVolume = _interopRequireDefault(require("./changeVolume"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }